import React from "react";
import { MessageCircle, TrendingUp } from "lucide-react";
import { WHATSAPP_GROUP } from "../mock";

export default function HeroActions() {
  return (
    <section className="bg-[#1a1a1a] text-[#FBF8F4]" data-testid="hero-actions-band">
      <div className="container-y px-5 md:px-8 py-4 flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6">
        <a
          href="#affiliate"
          data-testid="hero-affiliate-btn"
          className="w-full sm:w-auto justify-center inline-flex items-center gap-2 px-6 py-3 bg-[#C9A961] text-[#1a1a1a] font-sans-y text-[12px] tracking-[0.18em] uppercase font-semibold hover:bg-[#d8bd7c] transition-colors"
        >
          <TrendingUp size={16} /> Become an Affiliate
        </a>
        <a
          href={WHATSAPP_GROUP}
          target="_blank"
          rel="noreferrer"
          data-testid="hero-whatsapp-btn"
          className="w-full sm:w-auto justify-center inline-flex items-center gap-2 px-6 py-3 bg-[#25D366] text-white font-sans-y text-[12px] tracking-[0.18em] uppercase font-semibold hover:bg-[#1EBE5B] transition-colors"
        >
          <MessageCircle size={16} /> WhatsApp Group
        </a>
      </div>
    </section>
  );
}
